"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropDown = exports.UmbDropDown = void 0;
const app_1 = require("app");
class UmbDropDown extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.umbraco-forms-field.dropdown';
    }
    BeforeInit() {
        this.el.forEach(el => {
            this.InitDropDown(el);
        });
    }
    InitDropDown(el) {
        const labelSelector = 'label.form-selected-item';
        el.addEventListener('change', function (ev) {
            const currentOption = $(this).find('option:selected').text();
            const label = $(ev.target).siblings(labelSelector);
            label.text(currentOption);
        });
    }
}
exports.UmbDropDown = UmbDropDown;
exports.DropDown = new UmbDropDown();
